module.exports = __webpack_public_path__ + "static/bgblw-83e4b8d0122f6c467a6ad4f4c4430c38.jpg";